export enum ContractsActions {
  Reset = "reset",
  FetchContracts = "fetchContracts",
}
